import { Link } from 'react-router-dom';
import { Tag, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';
import { SiteLink } from '@/components/SiteLink';
import CrossSiteLink from '@/lib/siteLink';
import NetworkFooter from './NetworkFooter';
import SiteSwitcher from '@/components/SiteSwitcher';

const categories = [
  { id: 'food', label: 'Food & Dining' },
  { id: 'fashion', label: 'Fashion' },
  { id: 'electronics', label: 'Electronics' },
  { id: 'entertainment', label: 'Entertainment' },
  { id: 'travel', label: 'Travel' },
  { id: 'utility', label: 'Utility' },
];

export function CouponHeader() {
  const { user, logout } = useAuth();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100" data-testid="coupon-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* CrossSiteLink strips '/coupons' on metromandi.com → '/', matching CouponHome route */}
          <CrossSiteLink to="/coupons" className="flex items-center gap-2" data-testid="coupon-logo">
            <img src="/favicon-coupon-192.png" alt="" width="32" height="32" className="w-8 h-8 rounded-xl object-contain" />
            <span className="font-space-grotesk font-bold text-xl">MetroMandi</span>
          </CrossSiteLink>

          <div className="hidden md:flex items-center gap-6">
            {categories.map((cat) => (
              <CrossSiteLink key={cat.id} to={`/coupons/browse/${cat.id}`}
                className="text-sm font-medium text-gray-600 hover:text-[hsl(260,90%,60%)] transition-colors"
                data-testid={`nav-${cat.id}`}
              >{cat.label}</CrossSiteLink>
            ))}
            <CrossSiteLink to="/coupons/free-recharge" className="text-sm font-medium text-[hsl(260,90%,60%)] hover:text-[hsl(260,90%,50%)] transition-colors" data-testid="nav-free-recharge">
              Free Recharge
            </CrossSiteLink>
          </div>

          <div className="flex items-center gap-3">
            <SiteSwitcher className="md:hidden text-gray-600" />
            {user ? (
              <>
                <SiteLink to={user.role === 'admin' || user.role === 'super_admin' ? '/admin/dashboard' : user.role === 'affiliate' ? '/affiliate/dashboard' : '/app/dashboard'} site="admin">
                  <Button variant="outline" size="sm" className="rounded-md" data-testid="dashboard-link">Dashboard</Button>
                </SiteLink>
                <Button variant="ghost" size="sm" onClick={logout} className="text-gray-500 hover:text-red-500" data-testid="logout-btn">
                  <LogOut className="w-4 h-4 sm:mr-1.5" />
                  <span className="hidden sm:inline">Logout</span>
                </Button>
              </>
            ) : (
              <>
                <SiteLink to="/admin?redirect=coupon" site="admin" data-testid="login-link"><Button variant="ghost" size="sm">Login</Button></SiteLink>
                <SiteLink to="/admin?redirect=coupon" site="admin" data-testid="signup-link">
                  <Button size="sm" className="bg-gradient-to-r from-[hsl(260,90%,60%)] to-[hsl(320,80%,60%)] text-white rounded-xl">Sign Up</Button>
                </SiteLink>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export function CouponFooter() {
  return (
    <NetworkFooter
      activeSite="coupon"
      bgClass="bg-[hsl(260,40%,10%)]"
      disclaimer="Coupon codes and deals are sourced from third-party sites and may change without notice."
    />
  );
}
